import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import { FastField, Field } from "formik";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { AddPropertyFieldComponent } from "../property/PropertyField";
import { getFieldStatus } from "./common";

const DateField = withStyles({}, { name: "LcDateField" })(
  ({
    classes,
    name,
    label: labelProp = name,
    disabled: disabledProp,
    value: valueProp,
    fast = true,
    FieldComponent = fast ? FastField : Field,
    ...props
  }) => (
    <FieldComponent name={name}>
      {({ field, form }) => {
        const { error, hasError, disabled, label, value } = getFieldStatus(
          form,
          field,
          valueProp,
          labelProp,
          disabledProp
        );

        function handleDateChange(dt) {
          form.setFieldValue(name, dt);
          form.setFieldTouched(name, true, false);
        }

        function handleBlur() {
          form.setFieldTouched(name, true);
        }

        return (
          <KeyboardDatePicker
            disabled={disabled}
            variant="inline"
            label={label}
            value={value}
            onChange={handleDateChange}
            onBlur={handleBlur}
            format="MM/dd/yyyy"
            error={hasError}
            helperText={hasError && error}
            autoOk
            {...props}
          />
        );
      }}
    </FieldComponent>
  )
);

AddPropertyFieldComponent("date", DateField);

export default DateField;
